import React from 'react';

import { EventsListingNav } from './';

import { useGetEventsQuery } from 'common/store/modules/api/content-api';

export const EventsListing = (data) => {
    const eventId = data.eventId;
    const { data: events } = useGetEventsQuery(
        { eventId: eventId },
        { skip: !eventId }
    );

    if (!events) {
        return <>Empty</>;
    }

    return (
        <>
            <EventsListingNav {...data} events={events} />
        </>
    );
};

EventsListing.propTypes = {};
